var __WEBPACK_NAMESPACE_OBJECT__ = require("@sageworks/core-logic");